import { useLocation } from 'react-router-dom'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Table, Button, Alert } from 'reactstrap'
import { publishEvent } from '../../utils'
import { GET_STATISTICS_DETAIL_QUERY } from '../../graphql'
import PaginationPageControls from '../Pagination/PaginationPageControls'
import PaginationRecordMenu from '../Pagination/PaginationRecordMenu'

const GET_STATISTICS_DETAIL = gql(GET_STATISTICS_DETAIL_QUERY)

export default function StatisticsDetail({ parameters}) {
  console.log('StatisticsDetail rendered: ', parameters)

  const location = useLocation()

  const { loading, error, data } = useQuery(GET_STATISTICS_DETAIL, {
    variables: {
      eventId: parameters.eventId,
      eventUserId: parameters.userId,
      fromDate: parameters.fromDate,
      toDate: parameters.toDate,
      start: parameters.start
    }
  })

  if (loading) {
    return <Spinner />
  }
  if (error) {
    return <Alert color="danger">{error.message}</Alert>
  }

  console.log('loading: ', loading, 'error: ', error, 'data: ', data)

  function userClicked(userId) {
    publishEvent('STATISTICS USER CLICKED', userId, 'StatisticsDetail.userClicked')
  }

  function eventClicked(eventId) {
    publishEvent('STATISTICS EVENT CLICKED', eventId, 'StatisticsDetail.eventClicked')
  }

  const rows = []
  if (data.getStatisticsDetail) {
    data.getStatisticsDetail.events.forEach((dataRow, index) => {
      const row =
        <tr key={index}>
          <td>{parameters.start+index}</td>
          <td>{dataRow.eventDate}</td>
          <td><Button className="statistics-detail-link" color="link" onClick={() => userClicked(dataRow.userId)}>{dataRow.userName}</Button></td>
          <td><Button className="statistics-detail-link" color="link" onClick={() => eventClicked(dataRow.eventId)}>{dataRow.eventName}</Button></td>
          <td className="right">{dataRow.seconds}</td>
          <td>{dataRow.info}</td>
        </tr>
      rows.push(row)
    })
  }

  return (
    <div className="statistics-grid-container">
      <div className="statistics-grid-header">
        <h3>Statistics Detail</h3>
      </div>
      <PaginationRecordMenu results={data.getStatisticsDetail} inputs={parameters} location={location} />
      <PaginationPageControls results={data.getStatisticsDetail} />
      <div className="statistics-grid-table-container">
        <Table className="statistics-grid-table" bordered size="sm">
          <thead>
            <tr>
              <th>#</th>
              <th>Date/Time</th>
              <th>User</th>
              <th>Event</th>
              <th>Seconds</th>
              <th>Info</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </div>
      <PaginationPageControls results={data.getStatisticsDetail} />
    </div>
  )
}